module.exports = __webpack_public_path__ + "static/media/address.b7a011c7.png";